import React from "react";
import classNames from "classnames";
import { IconProps, IconDimensions } from "../../types";
import { getIconDimensions } from "../../../utils/icon-utils";

export const IconCheck = ({
  title,
  titleId,
  color,
  className: classNameProp,
  size,
  height,
  width,
  ...restProps
}: IconProps) => {
  const className = classNames(
    {
      [`text-${color}`]: color !== undefined,
    },
    classNameProp
  );

  const defaultDimensions: IconDimensions = {
    height: 24,
    width: 24,
  };
  const props = {
    className,
    ...getIconDimensions(size, width, height, defaultDimensions?.width, defaultDimensions?.height),
    ...restProps,
  };

  return (
    <svg viewBox="0 0 24 24" fill="currentcolor" {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#prefix__clip0)">
        <path
          d="m9.08 15.681 9.7-9.902a.6.6 0 01.848-.009l.572.56a.6.6 0 01.009.848L9.52 18.09a.6.6 0 01-.852.005l-4.96-4.947a.6.6 0 01-.001-.849l.565-.566a.6.6 0 01.848-.001l3.96 3.95Z"
          fill="currentcolor"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

IconCheck.displayName = "IconCheck";
